
import { useBaseMfaState } from './hooks/useBaseMfaState';
import { useMfaFactors } from './hooks/useMfaFactors';
import { useMfaChallenge } from './hooks/useMfaChallenge';
import { useMfaVerification } from './hooks/useMfaVerification';
import { useMfaEnrollment } from './hooks/useMfaEnrollment';
import { useMfaRecovery } from './hooks/useMfaRecovery';
import { MfaStateProvider } from './MfaStateContext';

// Export the provider for use at the app level
export { MfaStateProvider };

// This hook should be used within a MfaStateProvider
export function useMfaActions() {
  const baseState = useBaseMfaState();
  const { enrolledFactors, fetchMfaFactors } = useMfaFactors();
  const { initiateMfaChallenge } = useMfaChallenge();
  const { verifyMfaOtp } = useMfaVerification();
  const { enrollMfa, verifyMfaEnrollment, unenrollMfa } = useMfaEnrollment();
  const { generateRecoveryCodes, recoverMfaAccount } = useMfaRecovery();

  return {
    isLoading: baseState.isLoading,
    isMfaRequired: baseState.isMfaRequired,
    enrolledFactors,
    fetchMfaFactors,
    initiateMfaChallenge,
    verifyMfaOtp,
    enrollMfa,
    verifyMfaEnrollment,
    unenrollMfa,
    generateRecoveryCodes,
    recoverMfaAccount,
    resetMfaState: baseState.resetMfaState
  };
}
